module.exports = __webpack_public_path__ + "static/img/yi_banner.571fa14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yi_banner.jpg
// module id = qaEc
// module chunks = 0